import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbAccordionModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { Dictionary, groupBy, orderBy } from 'lodash';
import { RingSize, RingTypeEnum } from '../../core';
import { RingTypeLabelPipe } from '../pipe';


/**
 * Component to select tlhex rings.
 */
@Component({
	selector: 'ring-selection',
	templateUrl: './ring-selection.component.html',
	imports: [
		RingTypeLabelPipe,
		NgbDropdownModule,
		NgbAccordionModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class RingSelectionComponent {

	@Input() set list(items: RingSize[]) {
		if (items && items.length > 0) {
			const orderedList = orderBy(items, ['ringType', 'description'], ['asc', 'asc']);
			this.ringList = groupBy(orderedList, 'ringType');
		}
	}

	@Input() isFoot: boolean = false;
	@Input() disabled: boolean = false;
	@Input() placeholder: string = 'Select Ring';
	@Input() ngModel?: RingSize;
	@Output() ngModelChange: EventEmitter<RingSize> = new EventEmitter<RingSize>();

	ringList?: Dictionary<RingSize[]>;
	readonly ringTypeList: RingTypeEnum[] = [
		RingTypeEnum.FullRing,
		RingTypeEnum.OpenPosteriorRing,
		RingTypeEnum.OpenMedialRing,
		RingTypeEnum.OpenAnteriorRing,
		RingTypeEnum.FootPlate,
		RingTypeEnum.FullRing58Plus38
	];

	/**
	 * Get url of image ring type. 
	 */
	imageUrl(ringType: RingTypeEnum): string {
		switch (ringType) {
			case RingTypeEnum.FootPlate: return 'images/Rings/FootPlate.png';
			case RingTypeEnum.FullRing: return 'images/Rings/FullRing.png';
			case RingTypeEnum.FullRing58Plus38: return 'images/Rings/FullRing(58plus38).png';
			case RingTypeEnum.OpenAnteriorRing: return 'images/Rings/58OpenAnteriorlyRing.png';
			case RingTypeEnum.OpenMedialRing: return 'images/Rings/58OpenMediallyRing.png';
			case RingTypeEnum.OpenPosteriorRing: return 'images/Rings/58OpenPosteriorlyRing.png';
			default: return '';
		}
	}

	/**
	 * Update selected ring.
	 */
	select(item: RingSize): void {
		this.ngModel = item;
		this.ngModelChange.emit(item);
	}

}
